import { DATE_PIPE_DEFAULT_OPTIONS, DatePipe, DecimalPipe } from '@angular/common';
import { HTTP_INTERCEPTORS, provideHttpClient, withFetch, withInterceptorsFromDi } from '@angular/common/http';
import { EnvironmentProviders, Provider, inject, provideAppInitializer } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { AuthInterceptor } from '@interceptors/auth.interceptor';
import { ErrorResponceInterceptor } from '@interceptors/error-response.interceptor';
import { HeaderInterceptor } from '@interceptors/header.interceptor';
import { UrlInterceptor } from '@interceptors/url.interceptor';
import { UserService } from './core/services/user/user.service';

const isHealthcheckPath = window.location.pathname === '/up';

export const CORE_PROVIDERS: (Provider | EnvironmentProviders)[] = [
  { provide: HTTP_INTERCEPTORS, useClass: UrlInterceptor, multi: true },
  { provide: HTTP_INTERCEPTORS, useClass: HeaderInterceptor, multi: true },
  { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
  { provide: HTTP_INTERCEPTORS, useClass: ErrorResponceInterceptor, multi: true },
  provideAppInitializer(() => {
    if (isHealthcheckPath) return;
    return inject(UserService).getCurrentUser();
  }),
  provideHttpClient(withInterceptorsFromDi(), withFetch()),
  MatSnackBar,
  DatePipe,
  DecimalPipe,
  { provide: DATE_PIPE_DEFAULT_OPTIONS, useValue: { dateFormat: 'shortDate' } },
];
